<template>
  <div>
    <div class="full-height" v-loading="snykDiscoveryListReqStatus === 'loading'">
      <div class="table-toolbar" v-if="snykDiscoveryListReqStatus === 'saved'">
        <table-toolbar
          v-if="apiCalled"
          :key="snykDiscoveryList.key"
          :search-properties="visibleHostsColumns"
          :total-search-properties="hostsColumns"
          :search-data="snykDiscoveryList"
          :initial-tags="snykDiscoveryList.searchTags"
          :reload-component="snykDiscoveryList.reloadToolbar"
          @update-querydata="updateTableQueryData"
          @refresh-tabledata="refreshTableData"
          @update-columns-data="modifyColumnsData"
        >
        </table-toolbar>
      </div>

      <basic-table-element
        class="host-table"
        v-if="snykDiscoveryListReqStatus === 'saved' && apiCalled"
        ref="agentTable"
        :columns="visibleHostsColumns"
        :table-data="snykDiscoveryList"
        :height-offset="160"
        @update-record-count="recordCountHandler"
      ></basic-table-element>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { snykDiscoveryMetaInfo } from '@/column-header/hosts/snykdiscovery-meta'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import BasicTableElement from '@/components/table/BasicTableElement.vue'

import { SNYK_DISCOVERY_REQ } from '@/store/modules/agents/snyk-discovery.type'

export default {
  name: 'SnykDiscovery',
  data () {
    return {
      hostsColumns: snykDiscoveryMetaInfo.meta.columns,
      visibleHostsColumns: snykDiscoveryMetaInfo.meta.columns,
      apiCalled: false
    }
  },
  methods: {
    updateTableQueryData () {
      if (this.$refs.agentTable) {
        this.$refs.agentTable.updateTableData()
      }
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.snykDiscoveryList.key = !this.snykDiscoveryList.key
      this.snykDiscoveryList.reloadToolbar = false
    },
    modifyColumnsData (selectedColumns) {
      this.visibleHostsColumns = this.snykDiscoveryList.updateVisibleColumns(this.hostsColumns, selectedColumns)
    },
    callApi (tableMetaData) {
      this.$store.dispatch(SNYK_DISCOVERY_REQ).then(agents => {
        this.apiCalled = true
        this.setTableMetaData(tableMetaData)
      })
    },
    setTableMetaData (tableMetaData) {
      this.snykDiscoveryList.searchTags = tableMetaData.searchTags
      this.snykDiscoveryList.currentPage = tableMetaData.activePage
    },
    refreshTableData (tableMetaData) {
      this.apiCalled = false
      this.callApi(tableMetaData)
    }
  },
  created () {
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }
    this.callApi(tableMetaData)
  },
  computed: {
    ...mapGetters(['snykDiscoveryListReqStatus', 'snykDiscoveryList'])
  },
  components: {
    PageHeaders,
    TableToolbar,
    BasicTableElement
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/global_classes.css';
@import 'assets/styles/icon.css';

.table-toolbar {
  .el-button:last-of-type {
    .c-icon {
      border-left: 1px solid var(--border-color);
      padding-left: 10px;
    }
  }
}

>>> .el-radio {
  margin: 10px;
  line-height: 20px;

  .el-radio__label {
    vertical-align: middle;

    i {
      vertical-align: middle;
    }
  }
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.disabled {
  color: var(--tuna-400);
  cursor: not-allowed;
  .c-icon {
    color: var(--tuna-400);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/hosts/SnykDiscovery.vue